import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "position-relative" };
const _hoisted_2 = { class: "navbar navbar-expand-lg d-none d-lg-block main-nav p-1" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = {
    key: 0,
    class: "navbar-nav me-auto nav-left"
};
const _hoisted_5 = {
    key: 0,
    class: "nav-item dropdown py-1",
    id: "dropDownSwitch",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
};
const _hoisted_6 = {
    class: "d-flex h-100 justify-content-center align-items-center nav-switch text-nowrap",
    href: "#",
    role: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
};
const _hoisted_7 = { class: "small text-muted me-1" };
const _hoisted_8 = { class: "text-primary" };
const _hoisted_9 = {
    key: 0,
    class: "dropdown-menu",
    style: { "z-index": "1000", "border-radius": "5px" }
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
    key: 1,
    class: "nav-item py-1"
};
const _hoisted_12 = { class: "d-flex h-100 justify-content-center align-items-center nav-switch text-nowrap" };
const _hoisted_13 = { class: "small text-muted me-1" };
const _hoisted_14 = { class: "text-primary" };
const _hoisted_15 = { class: "nav-item" };
const _hoisted_16 = ["src"];
const _hoisted_17 = {
    key: 1,
    class: "nav-item"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
    key: 1,
    class: "navbar-nav navbar-right ms-2"
};
const _hoisted_20 = {
    key: 0,
    class: "navbar navbar-expand-lg d-none d-lg-block main-nav main-nav-second border-top-0",
    style: {}
};
const _hoisted_21 = { class: "container" };
const _hoisted_22 = { class: "collapse navbar-collapse justify-content-end" };
const _hoisted_23 = { class: "navbar-nav" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_ecommerce__nav_bar_item = _resolveComponent("g-ecommerce__nav-bar_item");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_ctx.mainMenuEntriesLeft.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenuEntriesLeft, (menuItem) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                                (menuItem.actionType === 'SWITCH')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (menuItem.children.length > 1)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (menuItem.children.length > 0)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                                                        _createElementVNode("a", _hoisted_6, [
                                                            _createElementVNode("span", _hoisted_7, _toDisplayString(menuItem.caption) + ":", 1),
                                                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currentMenu?.caption), 1),
                                                            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "mt-1 ms-1 bi bi-chevron-expand" }, null, -1))
                                                        ]),
                                                        (menuItem.children.length > 1)
                                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.children, (child) => {
                                                                    return (_openBlock(), _createElementBlock("li", null, [
                                                                        _createElementVNode("a", {
                                                                            class: _normalizeClass(['dropdown-item', _ctx.currentMenu?.menuID === child.menuID ? 'active' : '']),
                                                                            href: "#",
                                                                            onClick: _withModifiers(($event) => (_ctx.switchTo(child)), ["stop", "prevent"])
                                                                        }, _toDisplayString(child.caption), 11, _hoisted_10)
                                                                    ]));
                                                                }), 256))
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ], 64))
                                            : (menuItem.children.length > 0)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                                                    _createElementVNode("div", _hoisted_12, [
                                                        _createElementVNode("span", _hoisted_13, _toDisplayString(menuItem.caption) + ":", 1),
                                                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currentMenu?.caption), 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                        (_ctx.currentMenu)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.currentMenu.children, (menuItem2) => {
                                                return (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                                    _createVNode(_component_g_link, {
                                                        src: menuItem2.actionCommand,
                                                        target: menuItem2.actionTarget,
                                                        class: "nav-link text-nowrap"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (menuItem2.iconUrl)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: menuItem2.iconUrl
                                                                }, null, 8, _hoisted_16))
                                                                : _createCommentVNode("", true),
                                                            _createTextVNode(" " + _toDisplayString(menuItem2.caption), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["src", "target"])
                                                ]));
                                            }), 256))
                                            : _createCommentVNode("", true)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget,
                                            class: "nav-link text-nowrap"
                                        }, {
                                            default: _withCtx(() => [
                                                (menuItem.iconUrl)
                                                    ? (_openBlock(), _createElementBlock("img", {
                                                        key: 0,
                                                        src: menuItem.iconUrl
                                                    }, null, 8, _hoisted_18))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(" " + _toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target"])
                                    ]))
                            ], 64));
                        }), 256))
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.mainMenuEntriesRight && _ctx.mainMenuEntriesRight.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenuEntriesRight, (menuItem) => {
                            return (_openBlock(), _createBlock(_component_g_ecommerce__nav_bar_item, {
                                "nav-bar": _ctx._self,
                                "menu-item": menuItem,
                                align: "right"
                            }, null, 8, ["nav-bar", "menu-item"]));
                        }), 256))
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx._currentItem && _ctx._currentItem.children.length > 0)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("ul", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx._currentItem.children, (menuItem) => {
                                return (_openBlock(), _createBlock(_component_g_ecommerce__nav_bar_item, {
                                    "nav-bar": _ctx._self,
                                    "menu-item": menuItem,
                                    align: "right"
                                }, null, 8, ["nav-bar", "menu-item"]));
                            }), 256))
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
